import { ViewModel,View } from "binder"
import { AccountGatewaySelectorViewModel } from "src/erp/arap/rawData/accountGatewaySelector-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { IGateway, IPaymentInfoProvider } from "../IGateway";
import  { AccountGatewayView } from "./accountGateway-view"

export class AccountGatewayViewModel extends ViewModel implements IGateway{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }

    get title(): string {
        return 'واریز';
    }

    GetDefaultView(): View <ViewModel> {
        return new AccountGatewayView();
    }

    public getTypeId(): string {
        return "VM-CFE64A65-5D55-41DD-BF31-B4569927C994"
    }

    public set accountSelector(v: AccountGatewaySelectorViewModel) { this._accountSelector = v; } public get accountSelector(): AccountGatewaySelectorViewModel { return this._accountSelector;} private _accountSelector: AccountGatewaySelectorViewModel;
    public set traceCode(v: string) { this._traceCode = v; } public get traceCode(): string { return this._traceCode;} private _traceCode: string;

    initialLoad(): void {
        this.accountSelector = new AccountGatewaySelectorViewModel(this);
    }
    
    async save(dataProvider: IPaymentInfoProvider): Promise<any> {
        let paymentInfo = dataProvider.getBasePaymentInfoDto();
        return await ServerConnection.callServer('Complex/PaymentProcessServices/CreateTransferPayment',{
            ProcessId:paymentInfo.processId,
            Attachments:paymentInfo.attachments.map(p=>{
                return{
                    Data:p.content,
                    Name:p.name
                }
            }),
            SourceAccountId:this.accountSelector.selectedItem.id,
            TraceCode:this.traceCode
        });
    }
    
    validate(): string[] {
        let result = [];
        if(this.accountSelector.selectedItem==null){
            result.push('حساب مبدا تعیین نشده است.');
        }
        return result;
    }
    
    
}
